import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { HeadingGroup } from '@/components/ui/heading-group';
import { strings } from '@/constants/strings';
import { urls } from '@/constants/urls';
import { useOrganisations } from '@/hooks/use-organisations';
import { HeadingGroupContainerLayout } from '@/layouts/heading-group-container-layout';
import { composeTableOptions } from '@/table';
import { Organisation } from '@/types/organisation';

const columns: MRT_ColumnDef<Organisation>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    grow: true,
    size: 150,
    Cell: ({ renderedCellValue, row }) => (
      <Link to={urls.policies.organisation.compose(row.original.id)}>
        {renderedCellValue}
      </Link>
    ),
  },
];

export const PlatformPoliciesPage: FC = () => {
  const { data: organisations, isLoading: isLoadingOrganisations } =
    useOrganisations();

  const table = useMaterialReactTable({
    ...composeTableOptions<Organisation>({ enableRowActions: true }),
    columns,
    enableColumnResizing: true,
    data: organisations,
    state: {
      isLoading: isLoadingOrganisations,
      ...(isLoadingOrganisations
        ? {
            pagination: {
              pageIndex: 0,
              pageSize: 1,
            },
          }
        : {}),
    },
  });

  return (
    <>
      <HeadingGroupContainerLayout>
        <HeadingGroup
          subtitlePrefix={strings.policies.platform.subtitlePrefix}
          title={strings.devices.title}
        />
      </HeadingGroupContainerLayout>
      <MaterialReactTable table={table} />
    </>
  );
};
